module.exports = __webpack_public_path__ + "@/assets/img/040-boy-17.eab8758c.svg";